import React, { Component } from 'react';
import { Icon } from 'grab-ui';
import { AutoComplete, Tag, Tooltip } from '@duxton-web/ui';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';

const TEMPLATE_STATUS_MAP = {
  1: {
    text: 'ACTIVE',
    color: 'green',
  },
  2: {
    text: 'PENDING',
    color: 'orange',
  },
  3: {
    text: 'INACTIVE',
    color: 'red',
  },
  4: {
    text: 'DRAFT',
    color: 'yellow',
  },
};

const TEMPLATE_ID_REGEX = /^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/;
const WHATSAPP_STATUS = {
  APPROVED: 'approved',
  PENDING: 'pending',
  RECEIVED: 'received',
  REJECTED: 'rejected',
};

// Widget calls hedwig's new search endpoint to search template by name
export default class Widget extends Component {
  static propTypes = {
    appName: PropTypes.string.isRequired, // pax, dax or mex
    templateType: PropTypes.string.isRequired, // push, inbox, pushinbox, email or sms
    createdBy: PropTypes.string, // eslint-disable-line
    initialValue: PropTypes.string, // eslint-disable-line
    pageSize: PropTypes.number.isRequired,
    apiGatewayUrl: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired, // callback function, it takes in template object as input
    onError: PropTypes.func.isRequired, // callback function, it takes an error response
  };

  constructor(props) {
    super(props);
    this.state = {
      value: _.get(props, 'initialValue', ''),
      templates: [],
      noMatch: false,
    };
  }

  handleSelect = value => {
    if (!value) return;
    const data = JSON.parse(value) || {};
    this.setState({
      value: data.templateName,
    });
    this.props.onSelect(data);
  };

  // call to hedwig search API is capped at 1 per second
  submitSearch = _.throttle(query => {
    const url = `${this.props.apiGatewayUrl}/hedwig/v1/search`;

    axios
      .post(url, query)
      .then(res => {
        const retrievedTemplates = _.get(res, 'data.results', []);
        if (_.isEmpty(retrievedTemplates)) {
          this.setState({
            noMatch: true,
          });
        }
        this.setState({
          templates: retrievedTemplates,
        });
      })
      .catch(err => {
        this.props.onError(err);
      });
  }, 1000);

  buildQuery = input => {
    const value = _.trim(input);
    const conditions = [
      { lhs: 'templateType', opr: 'in', rhs: this.props.templateType },
      { lhs: 'templateStatus', opr: 'in', rhs: '1,2,4' }, // filter out inactive templates
      { lhs: 'appName', opr: 'in', rhs: `${this.props.appName},grab` },
    ];

    if (this.props.templateType === 'whatsapp') {
      conditions.push({
        lhs: 'twilioStatus',
        opr: 'eq',
        rhs: WHATSAPP_STATUS.APPROVED,
      });
    }

    if (!_.isEmpty(this.props.createdBy)) {
      conditions.push({
        lhs: 'createdBy',
        opr: 'eq',
        rhs: this.props.createdBy,
      });
    }

    if (_.size(value) >= 4) {
      // if the input is in a uuid form, search with template ID, otherwise search with name
      if (TEMPLATE_ID_REGEX.test(value)) {
        conditions.push({ lhs: 'templateId', opr: 'eq', rhs: value });
      } else {
        conditions.push({ lhs: 'templateName', opr: 'match', rhs: value });
      }
    }

    return {
      page: 1,
      size: this.props.pageSize,
      conditions,
    };
  };

  handleSearch = value => {
    this.setState({
      value,
      noMatch: false,
    });

    this.submitSearch(this.buildQuery(value));
  };

  render() {
    const items = _.map(this.state.templates, template => (
      <AutoComplete.Option
        key={JSON.stringify(template)}
        text={template.templateName}
      >
        <div>
          <p>{template.templateName}</p>
          <p>
            <span style={{ color: '#989797' }}>
              <Icon type="user" style={{ paddingRight: 5 }} />
              {template.createdBy}
            </span>{' '}
            &nbsp;&nbsp;
            <Tag
              color={_.get(
                TEMPLATE_STATUS_MAP,
                `${template.templateStatus}.color`,
                '',
              )}
            >
              {_.get(
                TEMPLATE_STATUS_MAP,
                `${template.templateStatus}.text`,
                '',
              )}
            </Tag>
            <Tag>{template.category}</Tag>
          </p>
        </div>
      </AutoComplete.Option>
    ));

    return (
      <React.Fragment>
        {_.size(this.state.value) > 0 &&
          _.size(this.state.value) < 4 && (
            <p style={{ color: 'red', fontSize: 12 }}>
              Type in at least 4 characters to search
            </p>
          )}
        {this.state.noMatch && (
          <p style={{ color: 'red', fontSize: 12 }}>No match found</p>
        )}
        <Tooltip placement="topLeft" title="Search with template name or ID">
          <AutoComplete
            value={this.state.value}
            dataSource={items}
            onSelect={this.handleSelect}
            onSearch={this.handleSearch}
            onFocus={() => {
              this.handleSearch(this.state.value);
            }}
            style={{
              width: '100%',
            }}
          />
        </Tooltip>
      </React.Fragment>
    );
  }
}
